import { Component, Input } from '@angular/core';
import { CompanyLogoConfiguration } from 'src/app/models/auxiliary/company-logo-configuration';
import { CommonDataService } from 'src/app/sections/common/services/common-data.service';

@Component({
  selector: 'app-cuotas-expand-list-report',
  templateUrl: './cuotas-expand-list-report.component.html',
  styleUrls: ['./cuotas-expand-list-report.component.scss']
})
export class CuotasExpandListReportComponent {

  @Input() reportId: string;
  @Input() data: [];
  @Input() paymentType: number;
  companyLogo: CompanyLogoConfiguration = null;

  date = new Date();

  constructor(public commonDataService: CommonDataService) {
    this.companyLogo = new CompanyLogoConfiguration();
  }
  ngOnInit() {
    this.commonDataService.getCompanyLogo().subscribe((labConfiguration: CompanyLogoConfiguration) => {
      this.companyLogo = labConfiguration;
    });
  }

}
